import { useCallback, useEffect, useState } from 'react'

import { MODAL_CLOSE_ANIMATION_MS } from 'features/bug-report/constants'

export type UseBugReportOverlayReturn = {
  isSelectingRegion: boolean
  shouldShowOverlay: boolean
  startSelecting: () => void
  finishSelecting: () => void
}

export function useBugReportOverlay(): UseBugReportOverlayReturn {
  const [isSelectingRegion, setIsSelectingRegion] = useState(false)
  const [shouldShowOverlay, setShouldShowOverlay] = useState(false)

  useEffect(() => {
    if (!isSelectingRegion) {
      setShouldShowOverlay(false)
      return
    }
    const timer = window.setTimeout(
      () => setShouldShowOverlay(true),
      MODAL_CLOSE_ANIMATION_MS,
    )
    return () => window.clearTimeout(timer)
  }, [isSelectingRegion])

  const startSelecting = useCallback((): void => {
    setIsSelectingRegion(true)
  }, [])

  const finishSelecting = useCallback((): void => {
    setIsSelectingRegion(false)
  }, [])

  return {
    isSelectingRegion,
    shouldShowOverlay,
    startSelecting,
    finishSelecting,
  }
}
